<template>
  <div class="logistics-list">
    <home-nav-bar title="物流">
      <div slot="right" class="nav-bar-right">
        <div class="title" @click="createLogistics">
          +添加物流
        </div>
      </div>
    </home-nav-bar>
    <wh-mobile-list ref="listTable" class="main" :extra-params="extraParams" data-src="/api/getLogisticsManagement">
      <template v-slot="{list}">
        <van-swipe-cell v-for="i in list" :key="i.id" :right-width="86">
          <div class="list-item wh-flex-between" @click="edit(i)">
            <van-image
              class="img"
              width="60"
              height="60"
              :src="i.photo|firstImgThumb"
            />
            <div class="info">
              <div class="info-name">
                {{ i.productName }}
              </div>
              <div class="info-phone">
                <span>{{ i.receiver }}</span>
                <span>{{ i.contactPhone }}</span>
              </div>
              <div class="info-address">
                {{ i.receiptAddress }}
              </div>
            </div>
            <div class="operation">
              <div>操作人 <span>{{ i.staffName }}</span></div>
              <div>{{ formatTime(i.operatingTime,'YYYY-MM-DD') }}</div>
            </div>
          </div>
          <template #right>
            <van-button square text="删除" style="height:100%;width:86px" type="danger" @click="delLogistics(i)" />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <logistics-popup
      :visible.sync="popup.logistics.visible"
      :form-type="popup.logistics.formType"
      :init-form-data="popup.logistics.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import api from '@/api'
import { firstImgThumb } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import LogisticsPopup from '@/views/Logistics/components/LogisticsPopup'
export default {
  components: { HomeNavBar, WhMobileList, LogisticsPopup },
  filters: {
    firstImgThumb
  },
  data() {
    return {
      extraParams: {

      },
      popup: {
        logistics: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      }
    }
  },
  methods: {
    formatTime,
    createLogistics() {
      this.popup.logistics.visible = true
      this.popup.logistics.formType = 'create'
    },
    edit(i) {
      this.popup.logistics.visible = true
      this.popup.logistics.formType = '编辑物流'
      this.popup.logistics.initFormData = {
        ...i
      }
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    },
    delLogistics(i) {
      this.$dialog.confirm({
        title: '是否删除该物流记录'
      })
        .then(() => {
          const params = {
            id: i.id
          }
          api.deleteLogisticsManagement(params).then(res => {
            this.$refs.listTable.onRefresh()
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="less" scoped>
.logistics-list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .nav-bar-right {
    .title{
      color: #20CAA0;
    }
  }
  .main{
    padding: 10px 0;
    .list-item{
      background-color: #fff;
      width: 100%;
      height: 92px;
      padding: 16px;
      margin-bottom: 8px;
      .img{
        width: 60px;
      }
      .info{
        padding: 0 20px;
        height: 100%;
        width: calc(100% - 150px);
        display: flex;
        color: #BBBBBB;
        flex-direction: column;
        justify-content: space-between;
        .info-name{
          font-size: 14px;
          color: #323332;
        }
        .info-phone{
          font-size: 12px;
          span{
            margin-right: 13px;
          }
        }
        .info-address{
          font-size: 12px;
        }
      }
      .operation{
        display: flex;
        width: 100px;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        font-size: 13px;
        >div:first-child{
          color: #20CAA0;
          span{
            color: #323332;
          }
        }
         >div:last-child{
           font-size: 12px;
           color: #323332;
         }
      }
    }
  }
}

</style>
